function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Nuevo-portal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Xs/Portal-Asociado-Menu",
  transform: "translate(-40.000000, -882.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "facebook-copy",
  transform: "translate(40.000000, 882.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-3",
  fill: "#1D548C",
  cx: 24.9542269,
  cy: 24.9542269,
  r: 24.9542269
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.5058013,18.283871 L28.2932758,18.283871 C27.4077597,18.283871 27.2281264,18.6520149 27.2281264,19.5813852 L27.2281264,21.6190489 L30.5058013,21.6190489 L30.16298,24.9542269 L27.2281264,24.9542269 L27.2281264,36.6279934 L22.3109815,36.6279934 L22.3109815,24.9542269 L19.0333066,24.9542269 L19.0333066,21.6190489 L22.3109815,21.6190489 L22.3109815,17.7702716 C22.3109815,14.8199713 23.8365994,13.2804604 27.2749322,13.2804604 L30.5058013,13.2804604 L30.5058013,18.283871 Z",
  id: "iconmonstr-facebook-4",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))));

function SvgLogoFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "986F5E9D-3C66-41A0-8A36-F72EF3C1193F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook);
export default __webpack_public_path__ + "static/media/logo-facebook.a33bb99c.svg";
export { ForwardRef as ReactComponent };